import { defineComponent, PropType } from '@vue/composition-api'
import { Popper as PtPopper } from 'patsnap-biz'
import { getAsyncListTippyConfig } from '../config'
import { BApprovalCountryFetchListCard } from './BApprovalCountryFetchListCard'
export const BApprovalCountryPopperListCard = defineComponent({
  name: 'BApprovalCountryPopperListCard',
  props: {
    ids: {
      type: Array as PropType<string[]>,
      required: true,
    },
  },
  render() {
    return (
      <PtPopper data={{ ids: this.ids }} tippyConfig={getAsyncListTippyConfig()} component={BApprovalCountryFetchListCard}>
        {this.$slots.default}
      </PtPopper>
    )
  },
})
